export enum StructuredDataKey {
  ProjekttitelEn = 'ProjekttitelEn',
  ProjekttitelSv = 'ProjekttitelSv',
  Projektsammanfattning = 'Projektsammanfattning',
  Uppfoljningsprojekt = 'Uppfoljningsprojekt',
  Projekttid = 'Projekttid',
  Projektparter = 'Projektparter',
  Firmatecknare = 'Firmatecknare',
  Projektledare = 'Projektledare',
  Bilagor = 'Bilagor',
  Belopp = 'Belopp',
  Budget = 'Budget',
  Klassificering = 'Klassificering',
  RapportOchSlutdatum = 'RapportOchSlutdatum',
  Signering = 'Signering',
}
